import { Component, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  roundCurrencyAmount,
} from '../../../helpers/allowance-funding.helper';

export interface AllowanceFundingAmountDialogData {
  memberCount: number;
  monthlyAmount: number;
}

export interface AllowanceFundingAmountDialogResult {
  fundingMode: 'prorated' | 'full';
}

@Component({
  selector: 'app-allowance-funding-amount-dialog',
  templateUrl: './allowance-funding-amount-dialog.component.html',
  styleUrls: ['./allowance-funding-amount-dialog.component.scss'],
})
export class AllowanceFundingAmountDialogComponent {
  public readonly fullAmount: number;
  public readonly memberCount: number;
  public readonly form;

  constructor(
    private readonly formBuilder: UntypedFormBuilder,
    public dialogRef: MatDialogRef<AllowanceFundingAmountDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AllowanceFundingAmountDialogData,
  ) {
    this.memberCount = Math.max(1, Number(data?.memberCount || 0));
    this.fullAmount = roundCurrencyAmount(Number(data?.monthlyAmount || 0));
    this.form = this.formBuilder.group({
      fundingMode: new UntypedFormControl('prorated', Validators.required),
    });
  }

  get previewTotal(): number {
    return roundCurrencyAmount(this.fullAmount * this.memberCount);
  }

  save(): void {
    if (!this.form.valid) {
      return;
    }

    this.dialogRef.close({
      fundingMode: this.form.get('fundingMode')?.value,
    } as AllowanceFundingAmountDialogResult);
  }

  onDismiss(): void {
    this.dialogRef.close(null);
  }
}
